













import { Component, Vue } from 'vue-property-decorator'
import Form from '@/components/Auth/Form.vue'
import { Step } from '@/types/form'
import { ApiService } from '@/api/api.service'
import { StepRight } from '@/types/form'
import { UserRequest } from '@/types/user'
import get from 'lodash/get'
import { UserModule } from '../../store/modules/user'
import { isValidEmail } from '@/utils/email'

function isEmailAlreadyUsed(error: Object): boolean {
    const emailErrorMsg = get(error, 'errors.children.email.errors[0]', '')
    return emailErrorMsg === 'Cette valeur est déjà utilisée.'
}

interface ValidateReturn {
    valid: boolean
    errorMessage: string
}

@Component({
    components: {
        Form,
    },
})
export default class Signup extends Vue {
    loading: boolean = true

    steps: Step[] = [
        {
            name: 'infos',
            valid: false,
            left:
                'Faisons connaissance ! Seuls votre prénom et la première lettre de votre nom seront visibles par les autres membres.',
            right: {
                type: 'step',
                title: 'Bonjour ! Comment vous appelez-vous ?',
                fields: [
                    {
                        name: 'firstname',
                        type: 'text',
                        value: '',
                        placeholder: 'Votre prénom',
                    },
                    {
                        name: 'lastname',
                        type: 'text',
                        value: '',
                        placeholder: 'Votre nom',
                    },
                ],
                isValid: async fields => {
                    return {
                        valid:
                            fields[0].trim() !== '' && fields[1].trim() !== '',
                        errorMessage:
                            (fields[0].trim() === '' ||
                                fields[1].trim() === '') &&
                            'Votre nom et prénom doivent contenir au moins une lettre',
                    }
                },
            },
        },
        {
            name: 'email',
            valid: false,
            left: `
                Nous avons besoin de communiquer avec vous pour construire votre projet. <br />
                Vos coordonnées ne seront pas transmises à des fins commerciales.
            `,
            right: {
                type: 'step',
                title: 'Votre adresse e-mail',
                info: 'Promis pas de spam',
                fields: [
                    {
                        name: 'email',
                        type: 'email',
                        value: '',
                        placeholder: 'Votre adresse e-mail',
                    },
                ],
                isValid: async fields => {
                    const email = fields[0].trim()

                    const valid = email !== '' && isValidEmail(email)

                    return {
                        valid,
                        errorMessage:
                            !valid && `Le format de votre email est incorrect`,
                    }
                },
            },
        },
        {
            name: 'phone',
            valid: false,
            left: `
                Nous avons besoin de communiquer avec vous pour construire votre projet. <br />
                Vos coordonnées ne seront pas transmises à des fins commerciales.
            `,
            right: {
                type: 'step',
                title: 'Votre numéro de téléphone',
                fields: [
                    {
                        name: 'phone',
                        type: 'phone',
                        value: '',
                        placeholder: 'Votre numéro de téléphone',
                    },
                ],
                isValid: async fields => {
                    const valid = fields[0].length === 10

                    if (valid) {
                        return await this.validate()
                    }

                    return {
                        valid,
                        errorMessage:
                            !valid &&
                            `Le format de votre numéro de téléphone est incorrect`,
                    }
                },
            },
        },
        {
            name: 'final',
            left: `
                Nous avons besoin de communiquer avec vous pour construire votre projet. <br />
                Vos coordonnées ne seront pas transmises à des fins commerciales.
            `,
            right: {
                type: 'final',
                text: `
                      Félicitations ! Votre inscription Yvivre est enregistrée ! <br />
                      Vous pouvez dès à présent vous rendre dans votre espace personnel, un mot de passe automatique vous a été envoyé par mail.
                  `,
                button: {
                    text: 'Allons-y !',
                    name: 'signin',
                },
            },
        },
    ]

    get infos(): { firstname: string; lastname: string } | null {
        const infosStep = this.steps.find(step => {
            return step.name === 'infos'
        })

        if (infosStep && infosStep.right.type === 'step') {
            const right = infosStep.right as StepRight

            const firstnameField = right.fields.find(field => {
                return field.name === 'firstname'
            })

            const lastnameField = right.fields.find(field => {
                return field.name === 'lastname'
            })

            const firstname = firstnameField.value
            const lastname = lastnameField.value

            return {
                firstname,
                lastname,
            }
        }

        return null
    }

    get email(): string | null {
        const emailStep = this.steps.find(step => {
            return step.name === 'email'
        })

        if (emailStep && emailStep.right.type === 'step') {
            const right = emailStep.right as StepRight

            const emailField = right.fields.find(field => {
                return field.name === 'email'
            })

            const email = emailField.value

            return email
        }

        return null
    }

    get phone(): string | null {
        const phoneStep = this.steps.find(step => {
            return step.name === 'phone'
        })

        if (phoneStep && phoneStep.right.type === 'step') {
            const right = phoneStep.right as StepRight

            const phoneField = right.fields.find(field => {
                return field.name === 'phone'
            })

            return phoneField.value
        }

        return null
    }

    async validate(): Promise<ValidateReturn> {
        const apiService = new ApiService()

        const req: UserRequest = {
            email: this.email,
            phone: this.phone,
            ...this.infos,
        }

        try {
            const resp = await apiService.postUser(req)
            const data = resp.data

            if (data.success) {
                await UserModule.Init()
                await UserModule.SetToken(data.token)

                return {
                    valid: true,
                    errorMessage: '',
                }
            }
        } catch (error) {
            if (isEmailAlreadyUsed(error.data)) {
                ;(this.$refs.form as Vue).$emit(
                    'goToStep',
                    this.steps.findIndex(step => {
                        return step.name === 'email'
                    })
                )
                return {
                    valid: false,
                    errorMessage: 'Cette adresse mail est déjà utilisée pour un autre compte existant',
                }
            }
        }

        return {
            valid: false,
            errorMessage: 'Une erreur est survenue lors de votre inscription',
        }
    }

    mounted() {
        setTimeout(() => {
            this.loading = false
        }, 2500)
    }
}
